/* eslint react/forbid-prop-types: 0 */
import React from "react";
import PropTypes from "prop-types";
import { Row, Col, Glyphicon } from "react-bootstrap";
import JobItemForm from "../../forms/JobItemForm";
import JobItemList from "../jobItems/JobItemList";

const JobEdit = props => {
  const { job } = props;
  const jobIdentifier = job.externalId || job.id;

  if (jobIdentifier) {
    const {
      activeJobItem,
      handleRemoveJobItem,
      handleEditJobItem,
      handleAddJobItem
    } = props;

    const action = activeJobItem.uuid || activeJobItem.id ? "Edit" : "Add";
    return (
      <Row>
        <Col md={7}>
          <JobItemList
            jobItems={job.jobItems}
            activeJobItem={activeJobItem}
            handleRemoveJobItem={handleRemoveJobItem}
            handleEditJobItem={handleEditJobItem}
          />
        </Col>
        <Col md={5}>
          <Row>
            <Col md={12}>
              <h3 className="title">
                <Glyphicon glyph="tasks" /> Item Form
              </h3>
            </Col>
          </Row>
          <JobItemForm
            action={action}
            initialValues={activeJobItem}
            onSubmit={handleAddJobItem}
          />
        </Col>
      </Row>
    );
  }

  return "";
};
JobEdit.propTypes = {
  job: PropTypes.object,
  activeJobItem: PropTypes.object,
  handleRemoveJobItem: PropTypes.func.isRequired,
  handleEditJobItem: PropTypes.func.isRequired,
  handleAddJobItem: PropTypes.func.isRequired
};
JobEdit.defaultProps = {
  job: {},
  activeJobItem: {}
};

export default JobEdit;



// WEBPACK FOOTER //
// ./src/components/jobs/JobEdit.js